import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { useAtedimento } from "../../../../Context/Atendimento";
import { useModuloInfo } from "../../../../Context/ModuloInfo";
import { CancelarCasoController } from "../../../../Controllers/Geral/Atendimentos/AtendimentosController";
import { ListartMotivoCancelamentoController } from "../../../../Controllers/Geral/GestaoDeCadastros/MotivoCancelamento/MotivoCancelamentoController";
import { IAtendimento } from "../../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";
import { MotivoCancelamentoInterfaceResponse } from "../../../../Interfaces/Geral/GestaoDeCadastro/MotivoCancelamento/MotivoCancelamentoInterfaces";
import SpinnerComponent from "../../../Loding/Spinner";

interface IFormDataProps {
    MotivoCancelamento: number;
    justificativa: string;
}

interface IPropsModal {
    setShow: (show: boolean) => void;
    Atendimento: IAtendimento;
}

export function CancelarCaso(props: IPropsModal) {
    const { register, formState, handleSubmit } = useForm();
    const [LstMotivoCancelamento, setLstMotivoCancelamento] =
        useState<Array<MotivoCancelamentoInterfaceResponse>>();
    const [ButtonSpinner, setButtonSpinner] = useState(false);
    const [ButtonProximoAtend, setButtonProximoAtend] = useState(false);
    const history = useHistory();

    const linkGestaoAtendimento = useModuloInfo().DS_URL_GESTAO_ATENDIMENTO;
    const { FL_MODO_ATENDIMENTO, goToNextAtendimento } = useAtedimento();

    useEffect(() => {
        ListartMotivoCancelamentoController().then((res) => {
            setLstMotivoCancelamento(res);
        });
    }, []);

    function handleFormSubmit(formData: IFormDataProps) {
        setButtonSpinner(true);
        CancelarCasoController({
            ID_CASO_MOTIVO_CANCELAMENTO: formData.MotivoCancelamento,
            ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO:
                props.Atendimento.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO,
            ID_ETAPA_TIPO_CASO:
                props.Atendimento.ID_ETAPA_TIPO_CASO ??
                props.Atendimento.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO,
            ID_CASO: props.Atendimento.ID_CASO,
            Justificativa: formData.justificativa,
        })
            .then(() => {
                setButtonSpinner(false);
                if (FL_MODO_ATENDIMENTO) {
                    setButtonProximoAtend(true);
                    goToNextAtendimento()
                        .then(() => {
                            props.setShow(false);
                        })
                        .finally(() => {
                            setButtonProximoAtend(false);
                        });
                } else {
                    setButtonSpinner(false);
                    props.setShow(false);
                    if (linkGestaoAtendimento)
                        history.push(linkGestaoAtendimento);
                }
            })
            .catch(() => {
                setButtonSpinner(false);
                props.setShow(false);
            });
    }

    return !ButtonProximoAtend ? (
        <form onSubmit={handleSubmit(handleFormSubmit)}>
            <div className="col-12 p-0">
                <label htmlFor="MotivoCancelamento">Motivo Cancelamento</label>
                <select
                    name="MotivoCancelamento"
                    className={`form-control placeholder-dark-50 ${
                        formState.errors.MotivoCancelamento && "is-invalid"
                    }`}
                    ref={register({
                        valueAsNumber: true,
                        required: "Insira um motivo cancelamento",
                    })}
                >
                    <option></option>
                    {LstMotivoCancelamento &&
                        LstMotivoCancelamento.map((motivo) => (
                            <option
                                key={motivo.ID_MOTIVO_CANCELAMENTO}
                                value={motivo.ID_MOTIVO_CANCELAMENTO}
                            >
                                {motivo.DS_MOTIVO_CANCELAMENTO}
                            </option>
                        ))}
                </select>
                <div className="invalid-feedback">
                    {formState.errors.MotivoCancelamento
                        ? formState.errors.MotivoCancelamento.message
                        : ""}
                </div>
            </div>
            <textarea
                name="justificativa"
                className={`form-control placeholder-dark-45 mt-5 mh-100 ${
                    formState.errors.justificativa && "is-invalid"
                }`}
                placeholder="Justificativa"
                style={{ minHeight: "40px", height: "150px" }}
                ref={register({
                    required: "Insira uma justificativa",
                })}
            />
            <div className="invalid-feedback">
                {formState.errors.justificativa
                    ? formState.errors.justificativa.message
                    : ""}
            </div>

            {ButtonSpinner ? (
                <button
                    type="button"
                    className="btn btn-outline-success font-weight-bold d-flex col-12 justify-content-center mt-5"
                >
                    <div className="row px-4">
                        <div className="loading-component">
                            <div
                                className="spinner-border spinner-border-sm text-light"
                                role="status"
                            >
                                <span className="sr-only">Carregando...</span>
                            </div>
                        </div>
                        <div className="ml-2">Confirmar Cancelamento</div>
                    </div>
                </button>
            ) : (
                <button className="btn btn-outline-success font-weight-bold d-flex col-12 justify-content-center mt-5">
                    Confirmar Cancelamento
                </button>
            )}
        </form>
    ) : (
        <div className="mt-4">
            <SpinnerComponent />
            <div className="d-flex justify-content-center align-items-center mt-4 mr-4">
                Buscando Próximo Atendimento
            </div>
        </div>
    );
}
